var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivateIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D1FADF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#ECFDF3",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.2426 23.7581C34.5858 26.1013 34.5858 29.9002 32.2426 32.2434M23.7574 32.2434C21.4142 29.9002 21.4142 26.1012 23.7574 23.7581M20.9289 35.0718C17.0237 31.1666 17.0237 24.8349 20.9289 20.9297M35.0711 20.9297C38.9763 24.835 38.9763 31.1666 35.0711 35.0719M30 28.0008C30 29.1053 29.1046 30.0008 28 30.0008C26.8954 30.0008 26 29.1053 26 28.0008C26 26.8962 26.8954 26.0008 28 26.0008C29.1046 26.0008 30 26.8962 30 28.0008Z",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivateIcon);
export default __webpack_public_path__ + "static/media/activateIcon.66da4c12eb5fe1305a7ace43ec2b817b.svg";
export { ForwardRef as ReactComponent };